/* eslint-disable no-console */
import angular from 'angular';

import { URL_PAYMENT } from 'common';

export default angular
    .module('application.scene.authorized.scene.payment', ['application.service'])
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('authorized.payment', {
        url: URL_PAYMENT,
        params: {
            plan: {
                dynamic: true
            },
            subscription: {
                dynamic: true
            }
        },
        data: {
            requires: {
                authentication: {
                    state: 'identity.sign-up',
                    keep: true
                }
            }
        }
    }).state('authorized.payment-confirm', {
        url: `${URL_PAYMENT}/confirm?ctrl&token`,
        params: {
            plan: {
                dynamic: true
            },
            subscription: {
                dynamic: true
            }
        }
    });

    $transitionsProvider.onStart({
        to: 'authorized.payment'
    }, (transition) => {
        let { subscription } = transition.params() || {};

        const $state = transition.injector().get('$state');
        const $window = transition.injector().get('$window');
        const paymentService = transition.injector().get('paymentService');
        const notificationService = transition.injector().get('notificationService');

        return paymentService.getBuyUrl(subscription).then((url) => {
            $window.location.replace(url);

            return true;
        }).catch(() => {
            notificationService.show({
                component: 'dbAAlreadySubscribedNotification',
                id: 'already-subscribed'
            }, false, 0);

            return $state.target('authorized');
        });
    });

    $transitionsProvider.onStart({
        to: 'authorized.payment-confirm'
    }, (transition) => {
        let { ctrl, token } = transition.params() || {};
    
        const $state = transition.injector().get('$state');
        const configuration = transition.injector().get('configuration');
        const sessionService = transition.injector().get('sessionService');
        const paymentService = transition.injector().get('paymentService');
        const notificationService = transition.injector().get('notificationService');
        
        // Get analytics service safely
        let analyticsService;
        try {
            analyticsService = transition.injector().get('analyticsService');
        } catch (error) {
            console.warn('Analytics service not available:', error);
        }
    
        return paymentService.confirm(ctrl, token).then(() => {
            // Since we're getting a 204 No Content response, we need to use default values
            // Use the token from URL params as the transaction ID
            const transactionId = token;
            // Use default values for amount and currency
            const value = 1.0;
            const currency = 'RON';
            
            // Track conversion if analytics service is available
            if (analyticsService && typeof analyticsService.trackPurchaseConversion === 'function') {
                console.log('Tracking purchase conversion:', { transactionId, value, currency });
                analyticsService.trackPurchaseConversion(transactionId, value, currency);
            } else {
                console.warn('Analytics service not available for tracking purchase conversion');
            }

            notificationService.showInfo(`Your payment went through and your account has been upgraded. Don't forget to add it as an expense. :)`, 'Hooray!', false);
            return sessionService.reload().then(() => $state.target('authorized'));
        }).catch((error) => {
            // Log error for debugging
            console.error('Payment confirmation error:', error);
            
            notificationService.showError(`Something might have gone wrong. If you don't receive your plan upgrade in the next 10 minutes, please contact us at ${configuration.supportEmail}.`, null, false, 0);
            return $state.target('authorized');
        });
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/payment/index.js